import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Collection } from "hanako-ts/dist-legacy/Collection";
export class ButtonAnimation {
    constructor(elements) {
        this.delay = 1000;
        this.highlightedButtonIndex = -1;
        this.orientation = '';
        this.elements = elements;
        $(window).on('resize', () => {
            this.resize();
        });
        this.resize();
        this.activeElements.each((element, index) => {
            setTimeout(() => {
                element.addClass('appear');
                element.on('animationend', () => {
                    element.removeClass('appear').addClass('bounce');
                }).on('mouseenter', () => {
                    this.activeElements.removeClass('highlighted');
                    element.removeClass('bounce').addClass('fixed');
                    clearInterval(this.highlightInterval);
                }).on('mouseleave', () => {
                    element.removeClass('fixed').addClass('bounce');
                    this.showButton(true);
                    this.highlightButtons();
                });
            }, this.delay + 125 * index);
        });
    }
    resize() {
        const currentOrientation = $(window).width() > $(window).height() ? 'landscape' : 'portrait';
        if (this.orientation === currentOrientation)
            return;
        this.activeElements = new Collection();
        this.elements.each((element) => {
            if (currentOrientation === 'landscape' || (currentOrientation === 'portrait' && !element.hasClass('d-none')))
                this.activeElements.add(element.get(0));
        });
        //this.activeElements.eq(0).addClass('highlighted');
        this.highlightButtons();
        if ($(window).width() < 992) {
            clearInterval(this.highlightInterval);
            $('.front-animation-btn-3').addClass('highlighted');
        }
        else {
            $('.front-animation-btn-3').removeClass('highlighted');
            this.highlightButtons();
        }
    }
    highlightButtons() {
        clearInterval(this.highlightInterval);
        this.highlightInterval = window.setInterval(() => {
            this.showButton();
        }, 3000);
    }
    showButton(ignoreIncrement = false) {
        if (!ignoreIncrement)
            this.highlightedButtonIndex = (this.highlightedButtonIndex + 1) % this.activeElements.length;
        this.activeElements.removeClass('highlighted');
        this.activeElements.eq(this.highlightedButtonIndex).addClass('highlighted');
    }
}
